
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4176_2320)"}},[_c('path',{attrs:{"d":"M4.972 12.332a.915.915 0 001.367-.38l.433-1.317A2.152 2.152 0 018.13 9.274l1.258-.41a.912.912 0 00-.035-1.736l-1.246-.404a2.148 2.148 0 01-1.36-1.359l-.41-1.259a.913.913 0 00-.334-.441.93.93 0 00-1.056 0 .916.916 0 00-.338.45L4.196 5.39A2.148 2.148 0 012.87 6.723l-1.26.409a.915.915 0 00.012 1.73l1.246.405c.404.135.76.387 1.022.723.15.194.264.41.34.642l.41 1.257c.063.18.18.334.334.443z","fill":"#7669BF"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4176_2320"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    